module.exports = __webpack_public_path__ + "492e9a70a32edb22272bf189bcab696d.svg";